// Centralized SEO configuration for PatientMesh public pages.
// Edit `SITE_URL` if the canonical domain ever changes.

export const SITE_URL =
  process.env.REACT_APP_SITE_URL || "https://patientmesh.com";
export const SITE_NAME = "PatientMesh";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/logo512.png`;
/** X (Twitter) @handle — link preview meta still uses the twitter:* namespace per spec */
export const X_SITE_HANDLE = process.env.REACT_APP_SOCIAL_X_HANDLE || "@patientmesh";
/** @deprecated use X_SITE_HANDLE */
export const TWITTER_HANDLE = X_SITE_HANDLE;

export const SOCIAL_PROFILES = {
  linkedin:
    process.env.REACT_APP_SOCIAL_LINKEDIN ||
    "https://www.linkedin.com/company/patientmesh",
  x: process.env.REACT_APP_SOCIAL_X || "https://x.com/patientmesh",
  instagram:
    process.env.REACT_APP_SOCIAL_INSTAGRAM ||
    "https://www.instagram.com/patientmesh/",
  facebook:
    process.env.REACT_APP_SOCIAL_FACEBOOK ||
    "https://www.facebook.com/patientmesh",
};

export const ORGANIZATION_SAME_AS = [
  SOCIAL_PROFILES.linkedin,
  SOCIAL_PROFILES.x,
  SOCIAL_PROFILES.instagram,
  SOCIAL_PROFILES.facebook,
];
export const SUPPORTED_LOCALES = ["tr", "en", "fr"];
export const DEFAULT_LOCALE = "en";

export const LOCALE_TO_OG = {
  tr: "tr_TR",
  en: "en_US",
  fr: "fr_FR",
};

export const ORGANIZATION_JSONLD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: SITE_NAME,
  legalName: "PatientMesh Health Technology",
  url: SITE_URL,
  logo: DEFAULT_OG_IMAGE,
  email: "info@patientmesh.com",
  sameAs: ORGANIZATION_SAME_AS,
  contactPoint: [
    {
      "@type": "ContactPoint",
      telephone: "+90-501-047-08-04",
      contactType: "customer support",
      availableLanguage: ["Turkish", "English", "French"],
    },
  ],
};

export const SOFTWARE_JSONLD = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: SITE_NAME,
  applicationCategory: "MedicalApplication",
  applicationSubCategory: "Patient Management & PROM Platform",
  operatingSystem: "Web, iOS, Android",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.9",
    reviewCount: "120",
  },
  publisher: { "@type": "Organization", name: SITE_NAME, url: SITE_URL },
};

export const buildCanonical = (path = "") => {
  if (!path || path === "/") return SITE_URL;
  return `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;
};

export const buildHreflangs = (path = "") => {
  const base = buildCanonical(path);
  return SUPPORTED_LOCALES.map((lng) => ({
    hrefLang: lng,
    href: base,
  })).concat([{ hrefLang: "x-default", href: base }]);
};
